import DocumentsTable from "@mirage/components/documentsTable/DocumentsTable";
import React from "react";

const BrDocumentsTabContent: React.FC<{ appId: number }> = ({ appId }) => {
    return (
        <DocumentsTable publicOnly={true} readOnly stateKey="bc-application-documents" displayFor={{ entityRecord: { entityName: "BC_APPLICATION", recordId: Number(appId) } }} />
    );
};

export default BrDocumentsTabContent;
